import {AnalyticsRoutesEnum} from 'interfaces'

import {FeatureHighlightMeta} from './types'

/**
 * Active feature highlight config.
 * Swap or edit this object when promoting a different feature.
 * Host/storage/snackbar code stays generic; copy lives in i18n.
 */
export const ACTIVE_FEATURE_HIGHLIGHT: FeatureHighlightMeta = {
  id: 'ai-usage',
  storageKey: 'ai-usage-feature-highlight-v1',
  i18nNamespace: 'aiUsage',
  titleKey: 'FEATURE_HIGHLIGHT_TITLE',
  messageKey: 'FEATURE_HIGHLIGHT_MESSAGE',
  ctaLabelKey: 'FEATURE_HIGHLIGHT_CTA',
  skipLabelKey: 'FEATURE_HIGHLIGHT_SKIP',
  eyebrowKey: 'FEATURE_HIGHLIGHT_EYEBROW',
  targetPath: AnalyticsRoutesEnum.ANALYTICS_AI_USAGE_APPS,
  routeMatch: AnalyticsRoutesEnum.ANALYTICS_AI_USAGE,
  requiresAdmin: true,
  requiresAnalyticsTenantAccess: true,
}

/**
 * Known highlight configs. Used to keep orphan storage cleanup scoped.
 * Add new highlight configs here when more than one can be active over time.
 */
export const FEATURE_HIGHLIGHTS: FeatureHighlightMeta[] = [
  ACTIVE_FEATURE_HIGHLIGHT,
]
